import SocialLinks from './SocialLinks';

export { SocialLinks };
export default SocialLinks;
